/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Cta_PInputs */

const es_l6_cta_p = /** @type {(inputs: L6_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos cuántos barcos gestionas y te preparamos el alta sin coste.`)
};

const gl_l6_cta_p = /** @type {(inputs: L6_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cóntanos cantos barcos xestionas e preparámoste o alta sen custo.`)
};

const en_l6_cta_p = /** @type {(inputs: L6_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us how many boats you manage and we will set you up at no cost.`)
};

/**
* | output |
* | --- |
* | "Tell us how many boats you manage and we will set you up at no cost." |
*
* @param {L6_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_cta_p = /** @type {((inputs?: L6_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_cta_p(inputs)
	if (locale === "en") return en_l6_cta_p(inputs)
	return es_l6_cta_p(inputs)
});